import { render, staticRenderFns } from "./health_list.vue?vue&type=template&id=9f7a30b6&scoped=true&"
import script from "./health_list.vue?vue&type=script&lang=js&"
export * from "./health_list.vue?vue&type=script&lang=js&"
import style0 from "./health_list.vue?vue&type=style&index=0&id=9f7a30b6&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f7a30b6",
  null
  
)

export default component.exports